import { render, staticRenderFns } from "./ClSlide.html?vue&type=template&id=226ccf53&"
import script from "./ClSlide.ts?vue&type=script&lang=ts&"
export * from "./ClSlide.ts?vue&type=script&lang=ts&"
import style0 from "./ClSlide.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports